import backofficeService from '../../api/backoffice'

export default {
  /**
   * Get list of categories
   * @param {*} params
   * @param {*} params.limit
   * @param {*} params.offset
   * @param {*} params.search
   * @param {*} params.local Add LocalData to categories
   */
  getAll(params) {
    return backofficeService.Api().get('merchantAccount', {
        params
      })
      .then(response => response.data)
      .catch((error) => {
        console.log('error on merchantAccount', error)
        throw error
      })
  },

  /**
   * Get category by id
   * @param {*} params Query Options
   */
  getById(id, params) {
    return backofficeService.Api().get(`merchantAccount/${id}`, {
        params
      })
      .then(response => response.data)
      .catch((error) => {
        throw error
      })
  },

  getByCustomerId(id, params) {
    return backofficeService.Api().get(`merchantAccount/${id}`, {
        params
      })
      .then(response => response.data)
      .catch((error) => {
        throw error
      })
  },

  create(data) {
    console.log('here in create', data)
    return backofficeService.Api().post('merchantAccount', data)
      .then(response => response)
      .catch((error) => {
        console.log('here in error', error)
        throw error
      })
  },
  /**
   * Update specific category
   * @param {*} id
   * @param {*} data
   */
  update(id, data) {
    return backofficeService.Api().put(`merchantAccount/${id}`, data)
      .then(response => response.data)
      .catch((error) => {
        throw error
      })
  },
  /**
   * Delete category
   * @param {} id
   * @param {*} params
   */
  delete(id, params) {
    return backofficeService.Api().delete(`merchantAccount/${id}`, {
        params
      })
      .then(response => response.data)
      .catch((error) => {
        throw error
      })
  },

  /**
   * Get All merchantAccountRights
   * @param {*} params
   
   */

  getAllmerchantAccountRights() {
    return backofficeService.Api().get('merchantAccountRightCatalog')
      .then(response => response.data)
      .catch((error) => {
        throw error
      })
  },

  /**
  * Get All AccountType
  * @param {*} params
  
  */

  getAllAccountType() {
    return backofficeService.Api().get('api/merchantAccount/accountType')
      .then(response => response.data)
      .catch((error) => {
        throw error
      })
  },
}